import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import icon from '@ckeditor/ckeditor5-list/theme/icons/bulletedlist.svg';
import { Model, addListToDropdown, createDropdown } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';
const FUNCTION_NAME = 'customULButton';
const UL_BUTTON_CLASS_NAME = 'ck-custom-ul-button';
const OL_BUTTON_CLASS_NAME = 'ck-custom-ol-button';
const setButtonLabel = (label) => {
  const ulLabelEl = document.querySelector(`.${UL_BUTTON_CLASS_NAME} .ck-button__label`);
  const olLabelEl = document.querySelector(`.${OL_BUTTON_CLASS_NAME} .ck-button__label`);
  if (ulLabelEl && olLabelEl) {
    ulLabelEl.innerHTML = label;
    ulLabelEl.style.paddingLeft = label ? '5px' : '0';
    olLabelEl.innerHTML = '';
  }
};
const clearButtonLabel = () => {
  setButtonLabel('');
};

export class CustomULButton extends Plugin {
  init() {
    const editor = this.editor;
    const ghs = this.editor.plugins.get('GeneralHtmlSupport');

    // 箇条書きリスト/番号付きリストを追加した場合、属性値を追加すること
    const itemList = editor.customList.getAllClassNames(); // /src/frontend/app/ckeditor/src/data/customListItems.js で一元管理しています
    const ulItems = editor.customList.getUlItems();
    const olItems = editor.customList.getOlItems();

    // 箇条書きリストの属性値情報
    const items = new Collection();

    // レイアウト変更時に選択されている要素からリストタイプを判定する
    this.editor.editing.view.document.on('layoutChanged', (evt) => {
      const domSelection = this.editor.editing.view.document.selection;
      const domConverter = this.editor.editing.view.domConverter;
      const viewRange = domSelection.getFirstRange();

      if (domConverter && viewRange) {
        // View Range→DOM Rangeへ変換
        const domRange = domConverter.viewRangeToDom(viewRange);

        // 選択された要素を取得
        let selectedElement = domRange.commonAncestorContainer;

        // テキストノードの場合は親要素を取得
        if (selectedElement.nodeType === Node.TEXT_NODE) {
          selectedElement = selectedElement.parentElement;
        }

        if (selectedElement) {
          const ulClassNames = ulItems.map((item) => item.className);
          for (const className of ulClassNames) {
            const el = selectedElement.closest(`.${className}`);
            if (el) {
              // 箇条書きリストのクラス名をもっている場合
              const labelItem = ulItems.find((item) => item.className === className);
              const label = labelItem ? labelItem.label : '';
              setButtonLabel(label);
              return;
            }
          }
          const olClassNames = olItems.map((item) => item.className);
          for (const className of olClassNames) {
            const el = selectedElement.closest(`.${className}`);
            if (el) {
              // 番号付きリストの場合は何もしない（ustomOLButton.jsで処理する）
              return;
            }
          }
        }

        clearButtonLabel(); // その他の場合はクリア
      }
    });

    ulItems.forEach((ulItem) => {
      items.add({
        type: 'button',
        model: new Model({
          withText: true,
          label: ulItem.label,
          labelStyle: ulItem.labelStyle,
          class: ulItem.className,
        }),
      });
    });

    editor.ui.componentFactory.add(FUNCTION_NAME, (locale) => {
      const dropdown = createDropdown(locale);
      addListToDropdown(dropdown, items);
      dropdown.buttonView.set({
        label: '',
        icon,
        tooltip: true,
        withText: true,
        class: UL_BUTTON_CLASS_NAME,
      });

      dropdown.bind('isEnabled').to(this.editor, 'isReadOnly', (value) => !value);

      this.listenTo(dropdown, 'execute', (evt) => {
        const label = evt.source.label;
        setButtonLabel(label);
        editor.model.change((writer) => {
          const selection = editor.model.document.selection;
          const blocks = [...selection.getSelectedBlocks()];

          blocks.forEach((element) => {
            let hasSameClass = false;
            // 箇条書きリスト/番号付きリストの属性を消す
            let nodeAttributes = element.getAttribute('htmlPAttributes');
            if (nodeAttributes && nodeAttributes.classes) {
              hasSameClass = nodeAttributes.classes.includes(evt.source.class);
              itemList.forEach((item) => {
                let idx = nodeAttributes.classes.indexOf(item);
                if (idx >= 0) ghs.removeModelHtmlClass('p', item, element);
              });
            }

            // すでに同じリストタイプを設定済みの場合、属性を追加しない（元に戻すため）
            if (hasSameClass === false) {
              ghs.addModelHtmlClass('p', evt.source.class, element);
            }

            if (nodeAttributes) {
              // start属性を消す
              if ('attributes' in nodeAttributes) {
                const oldValue = element.getAttribute('htmlPAttributes');
                const newValue = structuredClone(oldValue);
                delete newValue.attributes.start;
                writer.removeAttribute('htmlPAttributes', element);
                writer.setAttribute('htmlPAttributes', newValue, element);
              }
            }
          });

          return;
        });

        editor.editing.view.focus();
      });

      return dropdown;
    });
  }
}
